<div class="row">
  <div class="mdn-search-section" *ngIf="!validMDN">
    <div class="enter-mdn">
      <label for="phoneNumber">
        Enter your FreeUp mobile number for better results:
      </label>
      <input type="tel" required #phoneNumber="ngModel" [(ngModel)]="mdn" name="phoneNumber" id="phoneNumber"
        data-cy="phoneNumber" restrictNumbers maxlength="10" [disabled]="!!processingRequest">
    </div>
    <div class="search-mdn">
      <button class="button primary desktop" title="search" value="search" aria-label="search"
        [uiBlockButton]="processingRequest" [class.disabled]="mdn?.length < 10" [disabled]="mdn?.length < 10"
        (click)="checkMdn(mdn)">Search</button>
    </div>
  </div>
  <div class="twelve questions" *ngIf="!!validMDN">
    <div *ngFor="let item of SupportData | async">
      <div *ngFor="let qst of item?.fields?.supportQuestions">
        <a class="copy-icon-link"
          (click)="copy(true,!!isReload,qst?.fields?.questionId,item?.fields?.carrierId,qst?.fields?.answerId)"><img
            src="/assets/icon/Copy icon.svg" class="copy-icon" alt="copy icon"><span class="tool-tip-text">Copy question
            url</span> <span *ngIf="!!isCopied && qst?.fields?.questionId == questionIdParam"
            class="copied">Copied!</span></a>
        <app-question-answer question="{{qst?.fields?.questionText}}" [id]="qst?.fields?.questionId"
          [isActive]="qst?.fields?.questionId == questionIdParam"
          (click)="toggleActive(qst?.fields?.questionId, item?.fields?.carrierId, qst?.fields?.answerId)">
          <p (click)="collapsed=true" id="{{qst?.fields?.answerId}}"></p>
        </app-question-answer>
      </div>
    </div>
  </div>
</div>
